<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-solid">
        <div class="box-body">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Dosen</label>
                <div v-for="item in daftarRevisi" :key="item.id" class="radio">
                  <label>
                    <input v-model="revisi" type="radio" :value="item">
                    {{ item.dosen.nama }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div v-if="revisi" class="row">
            <div class="col-md-12">
              <strong>Uraian Revisi</strong>
              <p>{{ revisi.uraian }}</p>
            </div>
            <div class="col-md-12">
              <strong>Lampiran</strong>
              <template v-if="revisi.foto">
                <p><a :href="'/'+revisi.foto">Buka Berkas Lampiran</a></p>
              </template>
              <template v-else>
                <p><i>Tidak ada lampiran</i></p>
              </template>
            </div>
            <div class="col-md-12">
              <strong>Hasil Revisi Dilaporkan Kepada</strong>
              <p>
                <template v-if="revisi.dikoreksi_pembimbing == true">Pembimbing</template>
                <template v-else>Dosen Yang Bersangkutan</template>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  props: ['jenjang'],
  data: () => ({
    daftarRevisi: [],
    revisi: null,
  }),
  async created() {
    let dataUrl = '/mahasiswa/daftar-revisi/data'
    if (this.jenjang == 'S1') {
      dataUrl = '/s1' + dataUrl
    }
    let response = await axios.get(dataUrl)
    this.daftarRevisi = response.data
  },
}
</script>